import { render, staticRenderFns } from "./PasswordResetting.vue?vue&type=template&id=35376fb4&"
import script from "./PasswordResetting.vue?vue&type=script&lang=ts&"
export * from "./PasswordResetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports